/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Store_Badge_AltInputs */

const en_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App store badge`)
};

const id_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lencana App Store`)
};

const ms_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lencana App store`)
};

const ca_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insígnia de l'App store`)
};

const cs_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odznak obchodu App store`)
};

const da_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App store-badge`)
};

const de_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store-Abzeichen`)
};

const et_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store'i märk`)
};

const es_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insignia de App Store`)
};

const fr_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge App Store`)
};

const hr_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Značka App Storea`)
};

const it_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge App Store`)
};

const lv_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store emblēma`)
};

const lt_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„App Store“ ženklelis`)
};

const hu_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App store jelvény`)
};

const nl_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store-badge`)
};

const nb_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store-merke`)
};

const pl_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znaczek App Store`)
};

const pt_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ícone da App Store`)
};

const ro_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insigna App Store`)
};

const sk_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odznak App store`)
};

const sl_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Značka App store`)
};

const fi_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovelluskaupan merkki`)
};

const sv_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store-märke`)
};

const vi_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biểu tượng cửa hàng ứng dụng`)
};

const tr_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store rozeti`)
};

const el_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σήμα App store`)
};

const bg_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значка на App Store`)
};

const ru_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значок App store`)
};

const sr_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store значка`)
};

const uk_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значок App Store`)
};

const ka_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App store-ს ბეიჯი`)
};

const hi_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एप्प स्टोर बैज`)
};

const th_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้ายแสดงสถานะใน App Store`)
};

const ko_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱 스토어 배지`)
};

const zh_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App store  徽章`)
};

const zh_tw_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store 徽章`)
};

const ja_app_store_badge_alt = /** @type {(inputs: App_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Storeバッジ`)
};

/**
* | output |
* | --- |
* | "App store badge" |
*
* @param {App_Store_Badge_AltInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const app_store_badge_alt = /** @type {((inputs?: App_Store_Badge_AltInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Store_Badge_AltInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_app_store_badge_alt(inputs)
	if (locale === "ms") return ms_app_store_badge_alt(inputs)
	if (locale === "ca") return ca_app_store_badge_alt(inputs)
	if (locale === "cs") return cs_app_store_badge_alt(inputs)
	if (locale === "da") return da_app_store_badge_alt(inputs)
	if (locale === "de") return de_app_store_badge_alt(inputs)
	if (locale === "et") return et_app_store_badge_alt(inputs)
	if (locale === "es") return es_app_store_badge_alt(inputs)
	if (locale === "fr") return fr_app_store_badge_alt(inputs)
	if (locale === "hr") return hr_app_store_badge_alt(inputs)
	if (locale === "it") return it_app_store_badge_alt(inputs)
	if (locale === "lv") return lv_app_store_badge_alt(inputs)
	if (locale === "lt") return lt_app_store_badge_alt(inputs)
	if (locale === "hu") return hu_app_store_badge_alt(inputs)
	if (locale === "nl") return nl_app_store_badge_alt(inputs)
	if (locale === "nb") return nb_app_store_badge_alt(inputs)
	if (locale === "pl") return pl_app_store_badge_alt(inputs)
	if (locale === "pt") return pt_app_store_badge_alt(inputs)
	if (locale === "ro") return ro_app_store_badge_alt(inputs)
	if (locale === "sk") return sk_app_store_badge_alt(inputs)
	if (locale === "sl") return sl_app_store_badge_alt(inputs)
	if (locale === "fi") return fi_app_store_badge_alt(inputs)
	if (locale === "sv") return sv_app_store_badge_alt(inputs)
	if (locale === "vi") return vi_app_store_badge_alt(inputs)
	if (locale === "tr") return tr_app_store_badge_alt(inputs)
	if (locale === "el") return el_app_store_badge_alt(inputs)
	if (locale === "bg") return bg_app_store_badge_alt(inputs)
	if (locale === "ru") return ru_app_store_badge_alt(inputs)
	if (locale === "sr") return sr_app_store_badge_alt(inputs)
	if (locale === "uk") return uk_app_store_badge_alt(inputs)
	if (locale === "ka") return ka_app_store_badge_alt(inputs)
	if (locale === "hi") return hi_app_store_badge_alt(inputs)
	if (locale === "th") return th_app_store_badge_alt(inputs)
	if (locale === "ko") return ko_app_store_badge_alt(inputs)
	if (locale === "zh") return zh_app_store_badge_alt(inputs)
	if (locale === "zh-tw") return zh_tw_app_store_badge_alt(inputs)
	if (locale === "ja") return ja_app_store_badge_alt(inputs)
	return en_app_store_badge_alt(inputs)
});